"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MortgageLegalInfo = void 0;
var React = _interopRequireWildcard(require("react"));
var style = _interopRequireWildcard(require("./MortgageLegalInfo.css"));
var _uiKit = require("@cian/ui-kit");
var _clsx = _interopRequireDefault(require("clsx"));
var _icons = require("@cian/ui-kit-design-tokens/icons");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const TEXT_HEIGHT = 24;
const MortgageLegalInfo = props => {
  const {
    info
  } = props;
  const [isCollapsed, setIsCollapsed] = React.useState(true);
  const [isToggleEnabled, setIsToggleEnabled] = React.useState(true);
  const ref = React.useRef(null);
  React.useEffect(() => {
    if (!ref.current) {
      return;
    }
    setIsToggleEnabled(ref.current.clientHeight > TEXT_HEIGHT);
  }, []);
  const handleToggle = () => {
    setIsCollapsed(prev => !prev);
  };
  if (!info) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _clsx.default)(style['legal-info'], isCollapsed && style['legal-info--collapsed'])
  }, /*#__PURE__*/React.createElement(_uiKit.UIText1, {
    color: "text-secondary-default",
    ref: ref
  }, info), isToggleEnabled && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_uiKit.Responsive, {
    desktop: true,
    tablet: true
  }, /*#__PURE__*/React.createElement("div", {
    className: (0, _clsx.default)(style['icon'], style['icon--active'])
  }, /*#__PURE__*/React.createElement(_uiKit.InformationTooltip, {
    content: info,
    theme: "white",
    placement: "left-start"
  }, /*#__PURE__*/React.createElement("div", {
    className: style['icon--inner']
  }, /*#__PURE__*/React.createElement(_icons.IconFunctionalInformation16, {
    color: "icon-main-default"
  }))))), /*#__PURE__*/React.createElement(_uiKit.Responsive, {
    phone: true
  }, /*#__PURE__*/React.createElement("div", {
    className: (0, _clsx.default)(style['icon'], isCollapsed && style['icon--active']),
    onClick: isCollapsed ? handleToggle : undefined
  }, /*#__PURE__*/React.createElement("div", {
    className: style['icon--inner']
  }, /*#__PURE__*/React.createElement(_icons.IconActionChevronDownSmall16, {
    color: "icon-main-default"
  }))), /*#__PURE__*/React.createElement("div", {
    className: (0, _clsx.default)(style['collapse-control'], isCollapsed && style['collapse-control--collapsed'])
  }, /*#__PURE__*/React.createElement(_uiKit.ActionLink, {
    color: "current_color",
    onClick: handleToggle,
    afterIcon: /*#__PURE__*/React.createElement(_icons.IconActionChevronUpSmall16, {
      color: "icon-main-default"
    })
  }, "\u0421\u0432\u0435\u0440\u043D\u0443\u0442\u044C")))));
};
exports.MortgageLegalInfo = MortgageLegalInfo;